import React from 'react';
import { styled } from '@mui/system';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import * as MyStyles from "../styles/MyStyles";
import {ClearCookie} from "../logic/CookieManager";

// Остальной код компонента Navbar


const StyledAppBar = styled(AppBar)`
  background-color: ${MyStyles.Orange};
  height: 64px; /* Set the desired height */
  position: fixed; /* Add this line to make the component fixed */
  top: 0; /* Position it at the top of the viewport */
  width: 100%; /* Set the width to 100% */
  z-index: 999; /* Set a high z-index to ensure it appears above other elements */
`;

const StyledToolbar = styled(Toolbar)`
  background-color: ${MyStyles.White};
  display: flex;
  justify-content: space-between;
`;

const StyledTypography = styled(Typography)`
  color: ${MyStyles.Black};
  font-weight: bold;
`;

const StyledButton = styled(Button)`
  color: ${MyStyles.Black};
  font-weight: bold;
  text-transform: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    color: ${MyStyles.Orange};
    font-weight: bold;
  }
`;

const Navbar = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { isLoggedIn, setIsLoggedIn } = props;

    const handleLogout = () => {
        ClearCookie('nplt');
        setIsLoggedIn(false);
        navigate('/');
    };

    return (
        <StyledAppBar position="static">
            <StyledToolbar>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <StyledTypography variant="h6" component="div">
                        Newcent
                    </StyledTypography>
                </Link>
                <div>
                    {isLoggedIn ? (
                        <StyledButton color="inherit" onClick={handleLogout}>
                            Logout
                        </StyledButton>
                    ) : (
                        <StyledButton color="inherit" component={Link} to="/login" className={location.pathname === '/login' ? 'active' : ''}>
                            Login
                        </StyledButton>
                    )}
                </div>
            </StyledToolbar>
        </StyledAppBar>
    );
};

export default Navbar;
